// extracted by mini-css-extract-plugin
module.exports = {"overlayHidden":"Overlay_overlayHidden__1Up40","overlayActive":"Overlay_overlayActive__2AowR"};